import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import api from "../../api/api";

// FastAPI store: GET /api/v1/store/customer/{userId}/dashboard?token=...
export const get_dashboard_index_data = createAsyncThunk(
    'dashboard/get_dashboard_index_data',
    async(userId, { rejectWithValue, fulfillWithValue }) => {
        try {
            const token = localStorage.getItem('customerToken') || ''
            const { data } = await api.get(`/customer/${userId}/dashboard?token=${token}`)
            return fulfillWithValue(data)
        } catch (error) {
            return rejectWithValue(error.response?.data)
        }
    }
)

export const dashboardReducer = createSlice({
    name: 'dashboard',
    initialState: {
        recentOrders: [],
        errorMessage: '',
        successMessage: '',
        totalOrder: 0,
        pendingOrder: 0,
        cancelledOrder: 0,
    },
    reducers: {
        messageClear: (state) => {
            state.errorMessage = ''
            state.successMessage = ''
        }
    },
    extraReducers: (builder) => {
        builder
        .addCase(get_dashboard_index_data.fulfilled, (state, { payload }) => {
            state.totalOrder     = payload?.totalOrder     || 0
            state.pendingOrder   = payload?.pendingOrder   || 0
            state.cancelledOrder = payload?.cancelledOrder || 0
            state.recentOrders   = payload?.recentOrders   || []
        })
    }
})

export const { messageClear } = dashboardReducer.actions
export default dashboardReducer.reducer
